export default __webpack_public_path__ + "static/media/Copy of 22-reconfigure-your-firewall.41151461.jpg";